import { z } from "zod";

export const bulkUpdateVehicleContractDataRequest = z.object({
  companyUuid: z.uuid(),
  vehicles: z.array(
    z.object({
      registrationNumber: z.string().nullable(),
      reference: z.string().nullable(),
      contractStartDate: z.iso.datetime(),
      contractEndDate: z.iso.datetime(),
      contractMileage: z.number(),
      additionalCostPerKm: z.number(),
    }),
  ),
});

export type BulkUpdateVehicleContractDataRequest = z.infer<
  typeof bulkUpdateVehicleContractDataRequest
>;
